import { EmbedHTMLAttributes, forwardRef, ForwardRefRenderFunction } from 'react';

const Video: ForwardRefRenderFunction<HTMLEmbedElement, EmbedHTMLAttributes<HTMLEmbedElement>> = (props, ref) => {
    return <embed width="320" height="240" ref={ref} {...props} />;
};

const Embed = forwardRef(Video);

export default Embed;
